
import { useEffect, type JSX } from "react";
import { Controller, useForm } from "react-hook-form"
import type { FondUpdate } from "../../types/Fond";
import { FloatinBooleanBootstrap, FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useUpdateFondMutation } from "../../stores/OkOkStore";
import { Navigate } from "react-router";
import type { ResponseError } from "../../types/CommonReponse";
import {FondFraisSelector} from "./FondFraisSelector";
import TinyMceEditor from "../Common/TinyMceEditor";
import AttachmentSelector from "../Common/AttachmentSelector";
import { useTrads } from "../../contexts/trads/useTrads";

export function  FondEditForm ({fondParam,perso}:{ fondParam: FondUpdate,perso?:boolean}): JSX.Element {
    const [updateFond,result]=useUpdateFondMutation();
    const { register, handleSubmit,setValue,setError,control,watch, formState: { errors } } = useForm({
        defaultValues:fondParam,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    const publique=watch('publique');
    const noindex=watch('noindex');
    return (
        result.isSuccess ? <Navigate to={perso?'/perso':`/fond/${fondParam.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(updateFond)(event)}>
            <div className="col-6  mb-3">
                <FloatingInputBootStrap
                    name="name"
                    label={translate('fond_name')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("name", {
                        required: translate("fond_error_name_requis"),
                        minLength: 2
                    })} 
                />

            </div>

            <div className="col-6  mb-3">
                <FloatingInputBootStrap
                    name="year"
                    label={translate('fond_year')}
                    type="number"
                    errors={errors}
                    registerOutput= {register("year", {
                        required: translate("fond_error_year_requis"),
                        
                    })}
                />

            </div>
            
            <div className="col-6  mb-3">
                <FloatingInputBootStrap
                    name="date_debut"
                    label={translate('fond_date_debut')}
                    type="date"
                    errors={errors}
                    registerOutput= {register("date_debut", {
                        required: translate("fond_error_date_debut_requis"),
                        
                    })}
                />

            </div>

            <div className="col-6  mb-3">
                <FloatingInputBootStrap
                    name="date_fin"
                    label={translate('fond_date_fin')}
                    type="date"
                    errors={errors}
                    registerOutput= {register("date_fin", {
                        required: translate("fond_error_date_fin_requis"),
                        
                    })}
                />

            </div>

            <FondFraisSelector   
                    type_frais={fondParam.type_frais??[]}
                    setValue = {setValue}
                    register = {register}
                    errors={errors} >
                
            </FondFraisSelector>
            <div className="col-12  mb-3">
                <FloatinBooleanBootstrap
                    name="perso"
                    label={translate("fond_perso")}
                    errors={errors}
                    registerOutput= {register("perso", {} )}
                />
            </div>
            <div className="col-12  mb-3">
                <FloatinBooleanBootstrap
                    name="publique"
                    label={translate("fond_appel_publique")}
                    errors={errors}
                    registerOutput= {register("publique", {
                    
                    })}
                />
            </div>

            {publique?
            <div className="col-12  mb-3">
                <FloatinBooleanBootstrap
                    name="noindex"
                    label={translate("fond_noindex")}
                    errors={errors}
                    registerOutput= {register("noindex", {

                    })} 
                />

            </div>
            :null}

            {noindex?
                <div className="col-12  mb-3">
                    <FloatingInputBootStrap
                        name="password"
                        label={translate("fond_password")}
                        type="text"
                        errors={errors}
                        registerOutput= {register("password", {
                        })} 
                    />
                </div>
            :null}

           {publique?
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="objectif"
                    label={translate("fond_objectif")}
                    type="number"
                    rest={{"min":0}}
                    errors={errors}
                    registerOutput= {register("objectif", {

                    })} 
                />

            </div>
            :null}
            {publique?
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="titre"
                    label={translate("fond_titre")}
                    type="text"
                    errors={errors}
                    registerOutput= {register("titre", {})} 
                />

            </div>
             :null}            

            {publique?
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="prenom"
                    label={translate("fond_prenom")}
                    type="text"
                    errors={errors}
                    registerOutput= {register("prenom", {})} 
                />

            </div>
            :null}

            {publique?
            <div className="col-12  mb-3">
                <TinyMceEditor
                    control={control}
                    name="accroche"
                    label={translate("fond_accroche")}
                    maxLength={2000}
                    onChange={(data) => {setValue('accroche',data,{shouldValidate:true});}}
                />
            </div>
            :null}


            {publique?
            <div className="col-12  mb-3">
                <TinyMceEditor
                    control={control}
                    name="chapeau"
                    label={translate("fond_chapeau")}
                    onChange={(data) => {setValue('chapeau',data,{shouldValidate:true});}}
                />
            </div>
             :null}

            {publique?
            <div className="col-12  mb-3">
               
                <TinyMceEditor
                    control={control}
                    label={translate("fond_descriptif")}
                    name="descriptif"
                    onChange={(data) => {setValue('descriptif',data,{shouldValidate:true});}}
                />
            </div>
            :null}

            {publique?
            <div className="col-12  mb-3">
                <p>{translate('fond_vignette')}</p>
                <Controller
                        control={control}
                        name="vignette"
                        render={({ field }) => <AttachmentSelector {...field} />}
                />
            </div>
            :null}

            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default FondEditForm;